module.exports = {"id":"182888","name":"Håvard Nordtveit","rating":"76","photo":"./data/images/photos/0/182888.png","club":{"name":"1899 Hoffenheim","logo":"./data/images/clubs/1899Hoffenheim.png"},"positions":["DC","MDC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HavardNordtveit0.json
// module id = 1708
// module chunks = 0